import React from 'react';
import styles from './Announcements.module.scss';
import google from '@app/img/onboarding/google.svg';
import microsoft from '@app/img/onboarding/msft.svg';
import linkedin from '@app/img/onboarding/linkedin.svg';
import messages from '@app/img/onboarding/msg.svg';
import contacts from '@app/img/onboarding/contacts.svg';
import facebook from '@app/img/onboarding/facebook.svg';
import Button from '@components/Button';
import { useDispatch } from 'react-redux';
import { navigateToSettings } from '@actions/ui';

const integrationLogos = [google, microsoft, facebook, linkedin, messages, contacts];

export default function ConnectIntegrations() {
  const dispatch = useDispatch();
  return (
    <>
      <div className={styles.integrationsList}>
        {integrationLogos.map((logo, idx) => (
          <img src={logo} key={idx} />
        ))}
      </div>
      <div className={styles.copy}>
        We support email, calendar, Facebook, LinkedIn, iMessage, and Contacts.{' '}
        <Button
          className={styles.inlineBtn}
          onClick={() => dispatch(navigateToSettings({ panel: 'integrations' }))}
        >
          Connect more
        </Button>
      </div>
    </>
  );
}
